import { XF } from "../XF";

const guestImageButton = {
  title: "Insert Image",
  focus: false,
  undo: false,
  refreshAfterCallback: false,
  callback() {
    XF.toast("Log in or sign up to add an image to your post.");
  },
};

const guestAttachButton = {
  title: "Attachment",
  focus: false,
  undo: false,
  refreshAfterCallback: false,
  callback() {
    XF.toast("Log in or sign up to add a file to your post.");
  },
};

export { guestAttachButton, guestImageButton };
